import {
    MessageBlock,
    MessageBlockType
} from '@triumph/design-system';
import { useTranslation } from 'react-i18next';
import { ErrorMessageWrapper } from './AuthorizationError.StyledComponents';

export const AuthorizationError: React.FC = () => {
    const { t } = useTranslation('authorizationError');

    return <div>
        <ErrorMessageWrapper>            
            <MessageBlock message={t('expiredLink')} type={MessageBlockType.warning} messageId={0} show={true} width='auto'/>
        </ErrorMessageWrapper>
    </div>
}